/**
 * The two blocks of regulatory text the printed client report carries: the
 * notes at the foot of the first page, and the full גילוי נאות on the last
 * page. Wording supplied verbatim by Agio — do not paraphrase or "tidy" it.
 */

/** Foot of the first page: how the report was built, and what the figures mean. */
export function ReportNotes() {
  return (
    <section className="print-report-notes pt-4 text-[0.6rem] leading-snug text-neutral-700">
      <h3 className="mb-1 text-[0.65rem] font-bold text-neutral-800">הערות</h3>
      <ul className="list-disc space-y-0.5 pe-4">
        <li>דוח ריכוז הנכסים זה (להלן: "הדוח") נבנה בהתבסס על מידע ונתונים הנאספים מהגופים בהם הנכסים מתנהלים.</li>
        <li>
          על הגופים המנהלים נמנים, בין היתר, בנקים בארץ, בנקים בחו"ל, מנהלי תיקים ומנהלי נכסים פנסיוניים, מנהלי קרנות
          נאמנות ואחרים (להלן: "הגופים המנהלים").
        </li>
        <li>
          היתרות הסופיות לתאריך הדו"ח הינן כפי שתימסרנה על ידי הגופים המנהלים בדוחות הרבעוניים בלבד על פי הוראות הדין.
        </li>
        <li>
          עקב הנחיית הרשות, התשואה המוצגת בתיקי ההשקעות המנוהלים הינה <u>לפני מס, כלומר ברוטו.</u>
        </li>
        <li>
          שיעור התשואה הסופי בתיקי השקעות הינו השיעור אשר יחושב ויימסר בדוחות הרבעוניים בלבד על ידי בתי ההשקעות בהם
          הנכסים מנוהלים, בהתאם לתקנות הרשות לניירות ערך.
        </li>
        <li className="font-bold">
          אג'יו ניהול סיכונים והחלטות פיננסיות בע"מ הינה בעלת רישיון ניהול תיקים וייעוץ השקעות – נא ר' גילוי נאות בעמוד
          האחרון.
        </li>
      </ul>
    </section>
  );
}

/** Last page of the report, on its own: the full disclosure. */
export function DisclosurePage() {
  return (
    <div className="print-page print-page-fill print-section flex flex-col gap-4">
      <h2 className="print-heading">גילוי נאות – אג'יו ניהול סיכונים והחלטות פיננסיות בע"מ</h2>
      <ol className="list-decimal space-y-2 pe-5 text-[0.72rem] leading-relaxed text-neutral-800">
        <li>
          אג'יו ניהול סיכונים והחלטות פיננסיות בע"מ (להלן: "אג'יו") הינה בעלת רישיון לניהול תיקי השקעות לפי חוק הסדרת
          העיסוק בייעוץ השקעות, בשיווק השקעות ובניהול תיקי השקעות, התשנ"ה-1995.
        </li>
        <li>
          אג'יו מצהירה כי <strong>אינה בעלת זיקה</strong> למוצרים פיננסיים, לגופים מוסדיים, לחברות מנהלות או למי מטעמם,
          לפי הגדרת "זיקה" בחוק האמור.
        </li>
        <li>
          אג'יו מצהירה כי <strong>אינה מקבלת כל תמורה, תמריץ, טובת הנאה או כל הטבה אחרת</strong> מגורם כלשהו הקשור
          לניהול, שיווק או הנפקת מוצרים פיננסיים, וכי אין לה עניין אישי או מסחרי במתן ייעוץ או המלצות ביחס למוצרים
          פיננסיים מסוימים.
        </li>
        <li>
          השירותים, חוות הדעת, ניתוחי ההשקעה וההמלצות הניתנים על ידי אג'יו ללקוח מבוססים{' '}
          <strong>אך ורק על שיקולים מקצועיים ועל טובת הלקוח</strong>, בהסתמך על המידע שמוסר הלקוח ועל מידע פומבי נגיש.
        </li>
        <li>
          אג'יו אינה מתחייבת להשגת תשואה כלשהי. הלקוח מודע לכך כי כל השקעה בנכסים פיננסיים כרוכה בסיכונים, לרבות אפשרות
          להפסד חלקי או מלא של כספו.
        </li>
        <li>
          הלקוח מצהיר כי הוא ימסור לאג'יו מידע מלא, מדויק ועדכני לגבי מצבו הפיננסי, צרכיו, מטרות ההשקעה ונתונים
          רלוונטיים, וכי ידוע לו שהמידע שיימסר ישמש את אג'יו לצורך התאמת השירות ללקוח.
        </li>
      </ol>
    </div>
  );
}
